import React, { useMemo } from 'react';
import { ISelectOption } from 'components/Select/types';
import { TTypeOfReport } from 'types';
import { reportType } from 'appConstants';
import { Rule } from 'antd/lib/form';
import FormSelect from 'components/Select/FormSelect';
import { useTranslation } from 'react-i18next';

interface IReportTypeSelect {
	setIDReportType: (value: null | TTypeOfReport) => void;
	isDisabled: boolean;
}

const ReportTypeSelect: React.FC<IReportTypeSelect> = ({ setIDReportType, isDisabled }) => {
	const { t } = useTranslation('error');
	const { t: tForm } = useTranslation('form');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('selectReportType') }], [t]);

	const mappedOptions = useMemo<ISelectOption[]>(() => {
		const enabledTypes = ['Detailed', 'OrderWithError', 'Fees'];
		return reportType.map((el) => ({
			id: el.reportTypeID,
			name: tForm(el.reportTypeName),
			disabled: !enabledTypes.includes(el.reportTypeID), // TODO temporary remove other reports
		}));
	}, [tForm]);

	return (
		<FormSelect
			testId="ReportTypeSelect"
			name="IDReportType"
			label="reportTypeLabel"
			options={mappedOptions}
			onChange={setIDReportType}
			disabled={isDisabled}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(ReportTypeSelect);
